import {
  ChangeDetectorRef,
  Component,
  Inject,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';

import { State } from '®app/ngrx/state';
import { AppConfig } from '®shared/config';
import { LIST_ID } from '®shared/container-structure';
import { HideModalReason, ModalControlsSaveable } from '®shared/modals';
import { DEFAULT_NAVIGATION_EXTRAS } from '®shared/router';

import {
  ArchiveListAction,
  ArchiveListHideModalAction,
} from './archive-list.actions';
import { selectArchiveListState } from './archive-list.state';

@Component({
  selector: 'rl-archive-list-modal',
  templateUrl: './archive-list-modal.component.html',
})
export class ArchiveListModalComponent implements OnDestroy, OnInit {
  @ViewChild('archiveListModal', { static: true })
  public archiveListModal: ModalDirective;

  private stateSubscription: Subscription;
  modalControl: ModalControlsSaveable;
  modalHiddenReason: HideModalReason;

  constructor(
    private appConfig: AppConfig,
    private cd: ChangeDetectorRef,
    @Inject(LIST_ID) public listId: string,
    private router: Router,
    private store: Store<State>,
  ) {}

  ngOnInit() {
    this.stateSubscription = this.store
      .select(selectArchiveListState)
      .subscribe(state => {
        this.modalControl = state.modalControl;
        this.modalHiddenReason = state.modalHiddenReason;

        const { isShown } = state.modalControl;
        if (isShown && !this.archiveListModal.isShown) {
          this.archiveListModal.show();
        } else if (!isShown && this.archiveListModal.isShown) {
          this.archiveListModal.hide();
        }

        this.cd.markForCheck();
      });
  }

  ngOnDestroy() {
    if (this.stateSubscription) {
      this.stateSubscription.unsubscribe();
    }
  }

  onConfirm() {
    if (this.modalControl.isSaving) {
      return;
    }

    this.store.dispatch(new ArchiveListAction({ listId: this.listId }));
  }

  onCancel() {
    if (this.modalControl.isSaving) {
      return;
    }

    this.store.dispatch(
      new ArchiveListHideModalAction({
        listId: this.listId,
        reason: HideModalReason.CANCELLED,
      }),
    );
  }

  onHidden() {
    if (this.modalHiddenReason === HideModalReason.COMPLETED) {
      this.router.navigate(
        ['3', this.appConfig.tenant.shortCode, 'lists', `${this.listId}.html`],
        DEFAULT_NAVIGATION_EXTRAS,
      );
    } else {
      this.onCancel();
    }
  }
}
